import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import {Autoplay, FreeMode, Navigation, Thumbs } from 'swiper/modules';
import "./ProductsGallery.css"
function ProductsGallery({images,info}) {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const priceAfterPrec = info?.discounted_price_egp * 100
  const prec = 100 - (priceAfterPrec / info?.price_egp)

  return (
    <div className='garellry position-relative'>
      <Swiper
        style={{
          '--swiper-navigation-color': '#fff',
          '--swiper-pagination-color': '#fff',
        }}
        spaceBetween={10}
        navigation={true}
      loop
      
        autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[Autoplay,FreeMode, Navigation, Thumbs]}
        className="mySwiper2"
      >
        {images&&images.map((item,index)=>{
            
            return(
                <SwiperSlide key={index}>

                <img src={item?.image} alt="" />
              </SwiperSlide>
            )
        })}
   

      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        loop={true}
        spaceBetween={10}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper22"
      >

{images&&images.map((item,index)=>{
            
            return(
                <SwiperSlide key={index}>
                <img src={item.image} alt="" />
              </SwiperSlide>
            )
        })}
      </Swiper>
                                {info && info.discounted_price_egp != 0 &&
          <div className='media_small position-absolute top-0'style={{
            zIndex:"10000000000000000000"
          }}>
            <p
              className='bg-danger text-white rounded py-1 px-2'
            >{prec.toFixed(2)}%</p>
          </div>
        }
    </div>  )
}

export default ProductsGallery